import { object, string, ObjectSchema } from 'yup';

const validationSchema: ObjectSchema = object().shape({
  vinNumber: string()
    .required('El campo de número de chasis es obligatorio')
    .min(10, 'El campo de número de chasis debe tener mínimo 10 caracteres')
    .max(17, 'La cantidad de caracteres no puede ser mayor a 17'),
  invoiceName: string().required(''),
  invoiceBase64: string().required(''),
});

export default validationSchema;
